import { Container, Stack, Text } from "@mantine/core";
import "../../Variables.scss";
import SmartWizLogo from "../../components/Logos/SmartWizLogo";
import { IconCircleCheckFilled } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppRoutes } from "@/constants.ts";
import { useEffect } from "react";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if this payment was from onboarding flow
  // Note: This is now a fallback case. The new onboarding flow uses
  // Stripe's onComplete callback to avoid redirects. This logic is kept
  // for backwards compatibility with any old checkout sessions.
  useEffect(() => {
    const isOnboardingPayment = localStorage.getItem(
      "onboarding_payment_in_progress"
    );

    if (isOnboardingPayment === "true") {
      // Clear the flags
      localStorage.removeItem("onboarding_payment_in_progress");
      localStorage.removeItem("onboarding_new_flow");

      // Redirect back to new onboarding route with payment success flag
      // The backend subscription data will be refreshed automatically
      setTimeout(() => {
        navigate(`${AppRoutes.gettingStarted}?payment_success=true`);
      }, 2000);
    }
  }, [navigate]);

  const submit = () => {
    const searchParams = new URLSearchParams(location.search);
    const checkoutId = searchParams.get("checkout");
    if (checkoutId) {
      navigate(`${AppRoutes.login}?checkout=${checkoutId}`);
    } else {
      navigate(AppRoutes.login);
    }
  };
  return (
    <Container className="auth-form-container" size="sm">
      <form onSubmit={submit}>
        <IconCircleCheckFilled size={90} style={{ color: "#12b886" }} />
        <h1 className="title">Welcome to SmartWiz</h1>
        <Text className="sign-up forgot-text" size="xl">
          You’re in! Return to the login screen to log in and start your
          SmartWiz journey.
        </Text>
        <Stack className="stack" gap="md">
          <button className="sign-in" type="submit" color="blue">
            Log In Now
          </button>
          <Text className="powered-by success">
            Powered by <SmartWizLogo isLoginPage={true} />
          </Text>
        </Stack>
      </form>
    </Container>
  );
};

export default PaymentSuccess;
